<template>
  <header class="site-header">
    <div class="site-header-inner">
      <img src="@/assets/heyitsme-logo-side-by-side.svg" alt="Hey, It's Me" class="header-logo" />
      <div class="site-header-actions">
        <a href="#" class="try-free-link" @click.prevent="scrollToSignup">Try It Free</a>
        <button class="top-login-link" type="button" @click="showLoginDialog = true">Login</button>
      </div>
    </div>
  </header>

  <div class="page-content-wrapper">
    <p class="logo-tagline">Bodies hold onto old patterns.<br class="tagline-break-desktop"><br class="tagline-break-mobile"> Hey, It's Me helps make new ones.</p>
    <p class="how-it-works-title hero-main-title" style="font-size:1.15rem; text-align:center; padding-bottom:15px; padding-top:20px; font-family:'Quicksand'; font-weight:500;">The <span style="font-weight:700;">tune-it-out-proof</span> tool for&nbsp;your&nbsp;mental&nbsp;wellness&nbsp;reminders.<br></p>
    <div class="hero-cta-row">
      <button class="hero-cta-button hero-cta-primary" type="button" @click="scrollToSignup">Try It Free</button>
      <button class="hero-cta-button hero-cta-secondary" type="button" @click="showLoginDialog = true">Already have an account?</button>
    </div>
    <div class="hello">            
      <div class="how-it-works-section hero-section">
        <div class="how-it-works-2col">
          <div class="how-it-works-col">
            <h2 class="how-it-works-title stay-wonderful-mobile hero-words-title" style="font-size:2.5rem; text-align:center; padding-bottom:0px; font-family:'StayWonderful';">Your own words, delivered&nbsp;back&nbsp;to&nbsp;you.</h2>
            <p class="how-it-works-desc hero-desc hero-intro-text" style="margin-bottom:20px;">
              Save the things you want to practice.<br>Hey, It's Me messages you like a friend until they stick.<br>
            </p>
            <div class="value-blurb-row">
              <div class="value-blurb-box value-blurb-box-1">
                <span class="value-blurb-text">New patterns you're building.</span>
              </div>
              <div class="value-blurb-box value-blurb-box-2">
                <span class="value-blurb-text">Things your inner child needs to hear.</span>
              </div>
              <div class="value-blurb-box value-blurb-box-3">
                <span class="value-blurb-text">Words of validation, love and support.</span>
              </div>
            </div>
            <div class="signup-container" ref="heroSignup">
              <SignupForm
                :form="form"
                :is-loading="isSignupLoading"
                @submit="onSignupFormSubmit"
                @show-login="showLoginDialog = true"
              />
            </div>

          </div>
        </div>
      </div>
      
      <div class="how-it-works-section" style="margin-top:20px;">
        <div class="how-it-works-2col">
          <div class="how-it-works-col">
            <p class="logo-tagline" style="font-size:2.75rem; margin-bottom:0px; padding-bottom:0px; text-align:center;">Reminders can work...</p>
            <p class="how-it-works-title hero-main-title" style="font-size:1rem; text-align:center; padding-bottom:30px; padding-top:20px; font-family:'Quicksand'; font-weight:500;">but Hey, It's Me is <span style="font-weight:700;">made for this.</span></p>
              <div class="comparison-2col">
          <div class="comparison-box">
            <h3 class="comparison-box-title comparison-box-title-reminders">Reminders</h3>
            <ul class="comparison-list comparison-list-dot">
              <li>Another app notification</li>
              <li>Same day, same&nbsp;time</li>
              <li>Full of other to&#8209;do items</li>
            </ul>
          </div>
          <div class="comparison-box">
            <h3 class="comparison-box-title comparison-box-title-heyitsme">Hey, It's Me</h3>
            <ul class="comparison-list comparison-list-leaf">
              <li>A warm email&nbsp;or&nbsp;text</li>
              <li>Delightfully unexpected</li>
              <li>Dedicated to&nbsp;wellness</li>
            </ul>
          </div>
        </div>
        <div class="screenshot-container">
              <img src="@/assets/heyitsme_screenshots.png" alt="Hey, It's Me" class="screenshot-class" />
            </div>
            </div>
          </div>
        </div>

    </div>

      <div class="how-it-works-section plain-section" style="margin-top:20px;">
        <div class="how-it-works-2col">
          <div class="plain-content">
            <div class="section-icon" aria-hidden="true">🌱</div>
            <h2 class="how-it-works-title" style="font-size:2.25rem; text-align:center; padding-bottom:0px; padding-top:0px; font-family:'StayWonderful';">What makes Hey, It's Me&nbsp;different</h2>
            <p class="how-it-works-desc" style="padding-bottom:15px; padding-top:15px; margin-top:0px; text-align:center">
              Receiving a warm email or text feels&nbsp;better&nbsp;than an app notification. <strong>We engage more with things that feel good.</strong>
              <br>
              <br>
              Your messages will surprise you throughout the week, and you won't know which one is coming. <strong>It's hard to tune out something unexpected.</strong>
              <br>
              <br>
              Hey, It's Me is dedicated to your self-growth content. <strong>You won't be confronted with everything else on your plate.</strong>
              <br>
              <br>
              You can use Hey, It's Me as your go-to place for saving quotes, affirmations, self-growth discoveries and more. <strong>They will continue to impact you instead of collecting dust in your journal or social media saves.</strong>
              <br>
              <br>
              Hey, It's Me embodies the version of you that's holding your self-growth vision clearly. <strong>It won't let you forget to practice, even when life gets busy.</strong>
              <br>
              <br>
              When you receive a message, past-you is checking in with present-you. <strong>It's an external way to practice your internal source of validation and love.</strong>
            </p>
          </div>
        </div>
      </div>

      <div class="how-it-works-section" style="margin-top:0px;">
        <div class="how-it-works-2col">
          <div class="how-it-works-col">
            <p class="logo-tagline" style="font-size:2.75rem; margin-bottom:0px; padding-bottom:0px; text-align:center;">You're already doing the work to&nbsp;heal&nbsp;and&nbsp;grow.</p>
            <p class="how-it-works-desc" style=" padding-top:0px; margin-top:20px; padding-bottom:0px; text-align: center;">
              Let <strong>Hey, It's Me</strong> take care of making&nbsp;sure&nbsp;it&nbsp;sticks.
            </p>
            <div class="signup-container">
        <SignupForm
          :form="form"
          :is-loading="isSignupLoading"
          @submit="onSignupFormSubmit"
          @show-login="showLoginDialog = true"
        />
          </div>
            </div>
        </div>
      </div>

    <SignupValidationDialog
      :show="showValidateDialog"
      :validation-error="validationError"
      :validation-code="validationCode"
      :is-loading="isValidationLoading"
      @close="showValidateDialog = false"
      @submit="submitValidationCode"
      @update:validationCode="val => validationCode = val"
    />

    <LoginDialog
      :show="showLoginDialog"
      :is-loading="isLoginLoading"
      :email="loginEmail"
      :message="loginRedirectMessage"
      @close="showLoginDialog = false"
      @submit="submitLogin"
      @update:email="val => loginEmail = val"
    />

    <LoginVerificationDialog
      :show="showLoginVerifyDialog"
      :is-loading="isLoginVerificationLoading"
      :error="loginError"
      :code-value="loginVerificationCode"
      @close="showLoginVerifyDialog = false"
      @submit="submitLoginVerificationCode"
      @update:codeValue="val => loginVerificationCode = val"
    />

    <LoginLinkSentDialog
      :show="showLoginSentDialog"
      @close="showLoginSentDialog = false"
    />

    <!-- Generic Signup Error Dialog -->
    <PopupDialog
      :show="showGenericSignupErrorDialog"
      type="error"
      title="Something Went Wrong"
      message="Please let me know that there's an issue by sending a message through the Contact Me link at the bottom of the page."
      primary-button-text="Ok"
      :show-cancel="false"
      @close="showGenericSignupErrorDialog = false"
      @confirm="showGenericSignupErrorDialog = false"
    />

    <!-- Welcome Dialog -->
    <PopupDialog
      :show="showWelcomeDialog"
      type="success"
      title="You're all set!"
      message="Welcome to Hey, It's Me! Check your email for a welcome message that will help get you started."
      primary-button-text="OK"
      :show-cancel="false"
      @close="showWelcomeDialog = false"
      @confirm="continueToAccount"
    />

    <!-- Signup Attempts Exceeded Dialog -->
    <PopupDialog
      :show="showSignupAttemptsExceededDialog"
      type="error"
      title="That's Too Many Tries"
      message="We only allow 3 tries. Please start the sign-up process again to receive a new verification code."
      primary-button-text="Start Over"
      :show-cancel="false"
      @close="showSignupAttemptsExceededDialog = false"
      @confirm="restartSignupProcess"
    />

    <!-- Login Attempts Exceeded Dialog -->
    <PopupDialog
      :show="showLoginAttemptsExceededDialog"
      type="error"
      title="That's Too Many Tries"
      message="We only allow 3 tries. Please start the login process over to try again."
      primary-button-text="Start Over"
      :show-cancel="false"
      @close="showLoginAttemptsExceededDialog = false"
      @confirm="restartLoginProcess"
    />

    <!-- Email Not Found Dialog -->
    <PopupDialog
      :show="showEmailNotFoundDialog"
      type="warning"
      title="Hm, We Can't Log You In"
      message="Is that the right email address? If you're new, sign up first, and then you can log in."
      primary-button-text="I'll Sign Up"
      cancel-button-text="I'll Try A Different Email"
      :show-cancel="true"
      @close="closeEmailNotFoundDialog"
      @confirm="switchToSignupFromEmailNotFound"
    />

      <!-- ...existing footer content... -->
  </div>
</template>

<script>
import { useApi } from '@/composables/useApi';
import { useValidation } from '@/composables/useValidation';
import { useDialogState } from '@/composables/useDialogState';
import PopupDialog from '@/components/shared/PopupDialog.vue';
import SignupValidationDialog from '@/components/home-page/SignupValidationDialog.vue';
import LoginDialog from '@/components/home-page/LoginDialog.vue';
import LoginVerificationDialog from '@/components/home-page/LoginVerificationDialog.vue';
import SignupForm from '@/components/home-page/SignupForm.vue';
import LoginLinkSentDialog from '@/components/home-page/LoginLinkSentDialog.vue';
import { reactive, ref, onMounted } from 'vue';
import { useRouter, useRoute } from 'vue-router';

export default {
  name: 'HelloWorld',
  components: {
    PopupDialog,
    SignupValidationDialog,
    LoginDialog,
    LoginVerificationDialog,
    SignupForm,
    LoginLinkSentDialog
  },
  props: {
    msg: String
  },
setup() {
    const api = useApi();
    const router = useRouter();
    const route = useRoute();
    const loginRedirectMessage = ref('');
    const loginRedirectTarget = ref('/account');

    // On mount, check if user is already authenticated
    onMounted(() => {
      if (route.query.login === 'required') {
        loginRedirectMessage.value = 'Please log in to access your account.';
        const rawRedirect = route.query.redirect;
        // Only allow internal paths — reject anything that could escape the origin
        const isValidRedirect = rawRedirect && rawRedirect.startsWith('/') && !rawRedirect.startsWith('//');
        loginRedirectTarget.value = isValidRedirect ? rawRedirect : '/account';
        showLoginDialog.value = true;
      }

      api.account.getAccount()
        .then(() => {
          // If successful, user is authenticated, redirect to account page
          router.push('/account');
        })
        .catch((err) => {
          // If 401, do nothing (show HelloWorld as normal)
          if (err && (err.status === 401 || (err.response && err.response.status === 401))) {
            // Not authenticated, stay on HelloWorld
          } else {
            // Other errors: optionally handle/log
            // console.error('getAccount error:', err);
          }
        });
    });
    const {
      sanitizeName,
      validateName,
      processName,
      sanitizeEmail,
      validateEmail,
      processEmail,
      sanitizeVerificationCode,
      processVerificationCode
    } = useValidation();
    const {
      showValidateDialog,
      showLoginDialog,
      showLoginSentDialog,
      showLoginVerifyDialog,
      showWelcomeDialog,
      showEmailNotFoundDialog,
      showSignupAttemptsExceededDialog,
      showLoginAttemptsExceededDialog,
      showGenericSignupErrorDialog,
      switchToLogin,
      continueToAccount,
      switchToSignupFromEmailNotFound,
      closeEmailNotFoundDialog,
      restartSignupProcess,
      restartLoginProcess
    } = useDialogState();

    const form = reactive({
      name: '',
      email: ''
    });
    // Loading states
    const isSignupLoading = ref(false);
    const isValidationLoading = ref(false);
    const isLoginLoading = ref(false);
    const isLoginVerificationLoading = ref(false);
    // Verification and login data
    const validationCode = ref('');
    const validationAttempts = ref(0);
    const validationError = ref('');
    const loginVerificationCode = ref('');
    const loginAttempts = ref(0);
    const loginError = ref('');
    const loginEmail = ref('');

    return {
      api,
      form,
      isSignupLoading,
      isValidationLoading,
      isLoginLoading,
      isLoginVerificationLoading,
      showValidateDialog,
      showLoginDialog,
      showLoginSentDialog,
      showLoginVerifyDialog,
      showWelcomeDialog,
      showEmailNotFoundDialog,
      showSignupAttemptsExceededDialog,
      showLoginAttemptsExceededDialog,
      showGenericSignupErrorDialog,
      validationCode,
      validationAttempts,
      validationError,
      loginVerificationCode,
      loginAttempts,
      loginError,
      loginEmail,
      loginRedirectMessage,
      loginRedirectTarget,
      sanitizeEmail,
      sanitizeName,
      sanitizeVerificationCode,
      validateEmail,
      validateName,
      processName,
      processEmail,
      processVerificationCode,
      // Dialog methods from composable
      switchToLogin: () => switchToLogin(form, loginEmail),
      continueToAccount: () => continueToAccount(router, showWelcomeDialog),
      switchToSignupFromEmailNotFound: () => switchToSignupFromEmailNotFound(form, loginEmail),
      closeEmailNotFoundDialog: () => closeEmailNotFoundDialog(showLoginDialog, loginEmail),
      restartSignupProcess: () => restartSignupProcess(form, validationCode, validationAttempts, validationError),
      restartLoginProcess: () => restartLoginProcess(loginVerificationCode, loginAttempts, loginError, showLoginDialog),
    };
  },
  methods: {
    // Sign-up form submission
    async submitForm() {
      if (this.isSignupLoading) return; // Prevent double-clicks
      // Validate using the raw value, not sanitized, and match browser pattern
      const name = this.form.name;
      if (!name || !/^[a-zA-Z\s\-']+$/.test(name.trim())) {
        alert(`Name must contain only letters, spaces, hyphens, and apostrophes. You entered: "${name}"`);
        return;
      }
      // Validate email using processEmail
      const emailValidation = this.processEmail(this.form.email);
      if (!emailValidation.isValid) {
        alert(emailValidation.error);
        return;
      }
      // Only sanitize before sending to API
      const sanitizedName = this.sanitizeName(this.form.name);
      const sanitizedEmail = emailValidation.sanitized;
      this.isSignupLoading = true;
      try {
        await this.api.account.signup(sanitizedName, sanitizedEmail);
        this.validationAttempts = 0;
        this.validationError = '';
        this.showValidateDialog = true;
      } catch (err) {
          this.showGenericSignupErrorDialog = true;
      } finally {
        this.isSignupLoading = false;
      }
    },

    // Sign-up validation code submission
    async submitValidationCode() {
      if (this.isValidationLoading) return;
      // Use validation utility for cleaner validation
      const codeValidation = this.processVerificationCode(this.validationCode);
      
      if (!codeValidation.isValid) {
        alert(codeValidation.error);
        return;
      }
      
      // Update with sanitized code
      this.validationCode = codeValidation.sanitized;
      
      this.isValidationLoading = true;
      try {
        await this.api.account.createAccount(this.form.name, this.form.email, codeValidation.sanitized);
        console.log('Account created successfully');
        // Clear form and dialog
        this.form.name = '';
        this.form.email = '';
        this.validationCode = '';
        this.validationAttempts = 0;
        this.validationError = '';
        this.showValidateDialog = false;
        
        // Show welcome dialog instead of navigating immediately
        this.showWelcomeDialog = true;
      } catch (err) {
        console.error('Account creation error:', err);
        if (err.message.includes('expired')) {
          this.validationError = err.message;
          this.validationCode = '';
        } else {
          this.validationAttempts++;
          if (this.validationAttempts >= 3) {
            // Maximum attempts reached, show dialog instead of alert
            this.showValidateDialog = false;
            this.showSignupAttemptsExceededDialog = true;
          } else {
            const remainingAttempts = 3 - this.validationAttempts;
            this.validationError = `I'm sorry, that wasn't the right code. You can try ${remainingAttempts} more time${remainingAttempts === 1 ? '' : 's'}.`;
            this.validationCode = ''; // Clear the code for retry
          }
        }
      } finally {
        this.isValidationLoading = false;
      }
    },

    // Login form submission
    async submitLogin() {
      if (this.isLoginLoading) return;
      // Sanitize the email value
      const emailValidation = this.processEmail(this.loginEmail);
      this.loginEmail = emailValidation.sanitized;
      
      this.isLoginLoading = true;
      try {
        await this.api.account.requestLoginCode(emailValidation.sanitized);
        
        // Close login dialog and show verification dialog
        this.showLoginDialog = false;
        this.loginAttempts = 0; // Reset attempts for new login
        this.loginError = ''; // Clear any previous error
        this.showLoginVerifyDialog = true;
        console.log('Login code request successful');
      } catch (err) {
        console.error('Login request error:', err);
        
        // Handle specific error cases
        if (err.message.includes('404') || err.message.toLowerCase().includes('not found')) {
          // Email not found - show dialog instead of confirm
          this.showLoginDialog = false;
          this.showEmailNotFoundDialog = true;
        } else {
          // Generic error handling
          alert(`Error requesting login code: ${err.message}`);
        }
      } finally {
        this.isLoginLoading = false;
      }
    },

    // Login verification code submission
    async submitLoginVerificationCode() {
      if (this.isLoginVerificationLoading) return; // Prevent double-clicks
      // Use validation utility for cleaner validation
      const codeValidation = this.processVerificationCode(this.loginVerificationCode);
      if (!codeValidation.isValid) {
        alert(codeValidation.error);
        return;
      }
      // Update with sanitized code
      this.loginVerificationCode = codeValidation.sanitized;
      this.isLoginVerificationLoading = true;
      try {
        // The backend now sets an httpOnly cookie for authentication.
        // No JWT is stored in localStorage or anywhere on the client.
        await this.api.account.login(this.loginEmail, codeValidation.sanitized);
        console.log('Login successful');
        // Clear dialogs and form
        this.showLoginVerifyDialog = false;
        this.loginVerificationCode = '';
        this.loginEmail = '';
        this.loginAttempts = 0;
        this.loginError = '';
        
        // Navigate to account page (or original destination if redirected from a protected route)
        this.$router.push(this.loginRedirectTarget || '/account');
      } catch (err) {
        console.error('Login verification error:', err);
        if (err.message.includes('expired')) {
          this.loginError = err.message;
          this.loginVerificationCode = '';
        } else {
          this.loginAttempts++;
          if (this.loginAttempts >= 3) {
            // Maximum attempts reached, show dialog instead of alert
            this.showLoginVerifyDialog = false;
            this.showLoginAttemptsExceededDialog = true;
          } else {
            // Show remaining attempts in dialog
            const remainingAttempts = 3 - this.loginAttempts;
            this.loginError = `I'm sorry, that wasn't the right code. You can try ${remainingAttempts} more time${remainingAttempts === 1 ? '' : 's'}.`;
            this.loginVerificationCode = ''; // Clear the code for retry
          }
        }
      } finally {
        this.isLoginVerificationLoading = false;
      }
    },

    onSignupFormSubmit(payload) {
      this.form.name = payload.name;
      this.form.email = payload.email;
      this.submitForm();
    },

    scrollToSignup() {
      this.$refs.heroSignup?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@600&display=swap');

/* Loading state for buttons */
.loading {
  pointer-events: none;
  opacity: 0.8;
}

html, body {
  margin: 0;
  padding: 0;
  width: 100%;
  max-width: 100vw;
  box-sizing: border-box;
  background: #f5eee6;
}

body {
  overflow-x: hidden;
}

.site-header {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 84px;
  background: #fff;
  border-bottom: 1px solid #DDD4C6;
  box-sizing: border-box;
  z-index: 1000;
}
.page-content-wrapper {
  padding-top: 84px; /* matches .site-header height so content isn't hidden underneath */
}
.site-header-inner {
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0 24px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.site-header-actions {
  display: flex;
  align-items: center;
  gap: 28px;
}
.header-logo {
  height: 68px;
  width: auto;
  display: block;
  margin-left: 20px;
}
.try-free-link {
  color: #7da47e;
  font-size: 1.25rem;
  font-weight: bold;
  text-decoration: none;
  white-space: nowrap;
  transition: color 0.2s;
}
.try-free-link:hover {
  color: #388E3C;
}
.inline-signup-link {
  color: #7da47e;
  font-weight: bold;
  text-decoration: none;
  transition: color 0.2s;
}
.inline-signup-link:hover {
  color: #388E3C;
}

.hello {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 10px;
  width: 100%; /* Add this */
  box-sizing: border-box; /* Add this */
  padding: 0 12px; /* Add this */
}
.potted-plant-class {
  max-width: 500px;
  min-width: 50px;
  height: auto;
  display: block;
  margin: 0 auto 5px auto;
  width: 100%;
  object-fit: contain;
}
.potted-plant-mobile {
  display: none;
}
.logo-tagline {
  font-family: 'LemonCupcakeBold', sans-serif;
  font-weight: 500;
  color: #7da47e;
  text-align: center;
  font-size: 3.25rem;
  max-width: 600px;
  margin: 0 auto;
  padding: 0 16px;
  box-sizing: border-box;
  line-height: 1;
}
.logo-tagline:first-of-type {
  padding-top: 40px;
}
.logo-tagline:last-of-type {
  padding-bottom: 18px;
}
.tagline-break-desktop {
  display: inline;
}
.tagline-break-mobile {
  display: none;
}
/* Higher specificity than ".how-it-works-col p { margin: 0; }" so the centering auto margins aren't overridden */
.how-it-works-col .logo-tagline {
  margin: -34px auto 14px auto;
}
.section-tagline {
  font-family: 'LemonCupcakeBold', sans-serif;
  font-weight: 600;
  color: #388E3C;
  text-align: center;
  padding-top: 10px;
  padding-bottom: 20px;
  font-size: 2rem;
  line-height:1;
}
.section-divider {
  width: 80px;
  border: none;
  border-top: 2px solid #7da47e;
  margin: 20px auto;
}
.hero-main-title {
  margin-bottom: 24px;
}
.hero-words-title {
  padding-top: 10px;
}
@media (min-width: 601px) {
  .hero-words-title {
    padding-top: 18px;
    margin-bottom: 10px;
  }
}
.hero-cta-row {
  display: flex;
  justify-content: center;
  gap: 16px;
  max-width: 620px;
  width: 100%;
  margin: 0 auto 50px auto;
  padding: 0 16px;
  box-sizing: border-box;
}
.hero-cta-button {
  flex: 1 1 0;
  min-width: 160px;
  padding: 10px 20px;
  border-radius: 30px;
  font-family: 'Quicksand', Avenir, Helvetica, Arial, sans-serif;
  font-weight: 700;
  font-size: 1rem;
  white-space: nowrap;
  cursor: pointer;
  text-align: center;
  border: 2px solid transparent;
  transition: background-color 0.2s, color 0.2s, border-color 0.2s;
}
.hero-cta-primary {
  background: #7da47e;
  color: #fff;
}
.hero-cta-primary:hover {
  background: #388E3C;
}
.hero-cta-secondary {
  background: #fff;
  color: #7da47e;
  border-color: #7da47e;
}
.hero-cta-secondary:hover {
  background: #f0f5f0;
}
@media (max-width: 600px) {
  .hero-cta-row {
    flex-direction: column;
    margin-bottom: 20px;
  }
  .hero-cta-button {
    white-space: normal;
  }
  .stay-wonderful-mobile {
    font-size: 2.25rem;
  }
}
.hero-logo-inline {
  font-family: 'LemonCupcakeBold', sans-serif;
  font-weight: 500;
}
.text-sparkle {
  display: inline-block;
  color: #7da47e;
  font-size: 1.1em;
  margin: 3px 0;
}
.hero-list-row {
  text-align: center;
}
.value-blurb-row {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  gap: 18px;
  margin: 0px 0 20px 0;
}
.value-blurb-box {
  width: 175px;
  height: 110px;
  border-radius: 22px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 10px;
  box-sizing: border-box;
  background: #fff;
  box-shadow: 0 4px 10px rgba(0,0,0,0.12);
}
.value-blurb-text {
  color: #7da47e;
  font-family: 'Quicksand', Avenir, Helvetica, Arial, sans-serif;
  font-weight: 700;
  font-size: 0.95rem;
  line-height: 1.25;
}
@media (max-width: 600px) {
  .value-blurb-row {
    gap: 10px;
    margin: 20px 0 20px 0;
  }
  .value-blurb-box {
    width: 90px;
    height: 84px;
    padding: 6px;
  }
  .value-blurb-text {
    font-size: 0.75rem;
  }
}
.section-arrow {
  text-align: center;
  color: #7da47e;
  font-size: 1.75rem;
  line-height: 1;
  margin: 20px 0;
}
@media (max-width: 600px) {
  .logo-tagline {
    font-size: 2.15rem;
    max-width: 95vw;
    width: 100%;
    box-sizing: border-box;
    padding: 0 5px;
  }
  .stay-wonderful-mobile {
    font-size: 2.25rem;
  }
  .logo-tagline:last-of-type {
    padding-bottom: 0px;
  }
  .tagline-break-desktop {
    display: none;
  }
  .tagline-break-mobile {
    display: inline;
  }
  .how-it-works-col .logo-tagline {
    margin-top: -10px;
  }
  .hero-desc {
    text-align: left;
  }
}
.screenshot-container {
  border: 1px solid #e5e5e5;
  border-radius: 10px;
  background: #fff;
  padding: 10px;
  box-sizing: border-box;
  width: 100%;
  max-width: 800px;
  margin: 20px auto 0px auto;
}
.screenshot-class {
  max-width: 100%;
  min-width: 100px;
  height: auto;
  display: block;
  margin: 0 auto;  /* Modified */
  width: 100%; /* Add this */
  object-fit: contain; /* Add this */
}
.centered-logo {
  display: block;
  margin: 2px auto 2px auto;
  width: 66vw;
  max-width: 350px;
  min-width: 120px;
  height: auto;
}
.logo-below-paragraph {
  margin-bottom: 6px;
}
.how-it-works-section {
  width: 100%;
  max-width: 700px;
  margin: 0px auto 0 auto; /* Standardized margin */
  padding: 0 20px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.hero-section {
  margin-top: -20px;
}
.comparison-2col {
  display: flex;
  flex-direction: row;
  gap: 24px;
  width: 100%;
}
.comparison-box {
  flex: 1 1 0;
  min-width: 0;
  padding: 20px;
  box-sizing: border-box;
  border: 1px solid #e5e5e5;
  border-radius: 10px;
  background: #fff;
  word-break: break-word;
  overflow-wrap: break-word;
}
.comparison-box-title {
  text-align: center;
  margin: 0 0 16px 0;
  font-size: 1.5rem;
  line-height: 1;
}
.comparison-box-title-heyitsme {
  font-family: 'LemonCupcakeBold';
  font-size: 2rem;
  font-weight:700;
}
.comparison-box-title-reminders {
  font-family: 'LemonCupcakeBold';
  font-size: 2rem;
  font-weight: normal
}
.comparison-list {
  list-style: none;
  margin: 0;
  padding: 0;
  font-family: 'Quicksand', Avenir, Helvetica, Arial, sans-serif;
  font-size: 1.1rem;
}
.comparison-list li {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  text-align: left;
}
.comparison-list li:not(:last-child) {
  margin-bottom: 10px;
}
.comparison-list-leaf li::before {
  content: '🌿';
  flex-shrink: 0;
}
.comparison-list-dot li::before {
  content: '\2022';
  color: #000;
  flex-shrink: 0;
  font-size: 1.2em;
  line-height: 1.1;
  margin-right: 4px;
}
@media (max-width: 700px) {
  .comparison-2col {
    gap: 10px;
  }
  .comparison-box {
    padding: 10px 8px;
  }
  .stay-wonderful-mobile {
    font-size: 2.25rem;
  }
  .comparison-box-title {
    font-size: 1.15rem;
  }
  .comparison-box-title-heyitsme {
    font-size: 1.65rem;
  }
  .comparison-box-title-reminders {
    font-size: 1.65rem;
  }
  .comparison-list {
    font-size: 0.85rem;
    margin-left: 10px;
  }
  .comparison-list li {
    gap: 6px;
  }
  .comparison-list-dot li::before {
    margin-left: 6px;
  }
}
@media (max-width: 320px) {
  .comparison-2col {
    flex-direction: column;
  }
  .stay-wonderful-mobile {
    font-size: 2.25rem;
  }
}
.how-it-works-2col {
  display: flex;
  flex-direction: column;
  gap: 32px;
  margin: 4px 0 0 0; /* Remove auto margins since parent handles centering */
  max-width: 100%; /* Take full width of parent */
  width: 100%;
}
.how-it-works-col {
  flex: 1 1 0;
  min-width: 0;
  padding: 25px;  /* Standardized padding */
  margin: 0;      /* Remove any margin */
  box-sizing: border-box;
  text-align: left;
  border: 1px solid #e5e5e5;
  border-radius: 10px;
  background: #f5f5f5;
  word-break: break-word;
  overflow-wrap: break-word;
  width: 100%;
  max-width: 100%;
  font-size: 1.25rem;
  font-family: 'Quicksand', Avenir, Helvetica, Arial, sans-serif;
}
.how-it-works-col p {
  margin: 0;
}

.how-it-works-col > *:last-child {
  margin-bottom: 0;
}

.plain-content {
  flex: 1 1 0;
  min-width: 0;
  padding: 10px 25px;
  margin: 0;
  box-sizing: border-box;
  text-align: left;
  word-break: break-word;
  overflow-wrap: break-word;
  width: 100%;
  max-width: 100%;
  font-size: 1.25rem;
  font-family: 'Quicksand', Avenir, Helvetica, Arial, sans-serif;
}
.plain-content p {
  margin: 0;
}
.plain-content > *:last-child {
  margin-bottom: 0;
}
.section-icon {
  text-align: center;
  font-size: 2.25rem;
  line-height: 1;
  margin-bottom: 25px;
}

/* Reset margins for specific elements that might add spacing */
.how-it-works-col ul {
  margin-bottom: 12px;
}

.how-it-works-title {
  margin: 0 0 16px 0;  /* Standardize title margins */
  line-height: 1;
}

.signup-container {
  width: 100%;
  max-width: 700px;
  margin: 25px auto 0 auto; /* Standardized margin */
  padding: 0;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0;
  scroll-margin-top: 80px; /* keep clear of the fixed header when scrolled into view */
}
.hero-section .signup-container {
  margin-top: 12px;
  scroll-margin-top: 100px; /* stop the Try It Free scroll ~20px earlier than the base signup-container */
}
.how-it-works-desc {
  margin-top: 0;
  font-size: 1rem;
  font-weight: 500;
  text-align: left;
}
.hero-desc {
  text-align: center;
}
.hero-intro-text {
  padding-top: 10px;
  margin-top: 0px;
}
.heart-mobile-only {
  display: none;
}
.heart-desktop-only {
  display: inline;
}
.how-it-works-title,
.about-title {
  text-align: center;
  display: block;
  width: 100%;
  margin-bottom: 16px;
}
.how-it-works-title.inline-cursive {
  display: inline;
  font-size: 1.7em;
  font-family: 'LemonCupcakeBold', 'Pacifico', 'Segoe Script', 'Brush Script MT', cursive;
  font-weight: 300;
  letter-spacing: 0.01em;
  color: #312d30;
  line-height: 1;
  vertical-align: baseline;
  padding: 0;
  margin: 0;
}
.top-login-link:hover {
  background: #388E3C;
}
/* Style for both top-login-link (now a button) and top-faq-link (still a link) */
.top-login-link, .top-faq-link {
  z-index: 1000;
  background: #7da47e;
  color: #fff;
  padding: 5px 16px;
  border-radius: 6px;
  font-family: inherit; /* <button> doesn't inherit the page font by default, making it look bolder */
  font-size: 1.1rem;
  font-weight: normal;
  text-decoration: none;
  box-shadow: 0 2px 8px rgba(0,0,0,0.04);
  transition: background 0.2s, box-shadow 0.2s;
  border: none;
  cursor: pointer;
  display: inline-block;
}
.top-faq-link {
  right: 140px;
  margin-left: 12px;
}
.top-login-link {
  margin-right: 20px; /* matches the header-logo's extra left offset so both sides have equal spacing */
  font-weight: 700;
}
.gobeyonddev-footer-logo-container {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 32px 0 0 0;
}
.footer-gobeyonddev-link {
  display: inline-flex;
  align-items: center;
}
.gobeyonddev-logo {
  height: 38px;
  width: auto;
  display: block;
}
@media (max-width: 700px) {
  .hello {
    margin-top: 15px;
    padding: 0 8px;
    width: 100%;
    box-sizing: border-box;
  }

  .potted-plant-class {
    max-width: 75%;
    width: 75%;
    height: auto;
    margin: 0 auto 12px auto;
    display: block;
  }
  .potted-plant-desktop {
    display: none;
  }
  .potted-plant-mobile {
    display: block;
  }

  .how-it-works-col {
    padding: 12px;
    margin: 0;
  }
  /* Hero box top padding (mobile only) */
  .hero-section .how-it-works-col {
    padding-top: 16px;
  }

  .how-it-works-section{
    margin: 0px auto 0 auto;
    padding: 0 8px;
    width: 100%;
  }

  /* Pull the hero box closer to the tagline above it on mobile */
  .hero-section {
    margin-top: 0px;
  }

  /* Shift this paragraph down a bit: more space above, less below */
  .hero-intro-text {
    padding-top: 6px;
  }
  .text-sparkle {
    margin: 10px 0 8px 0;
  }
  .hero-main-title {
    margin-bottom: 10px;
    font-size: 1.0rem !important;
  }
  .hero-logo-inline {
    height: 34px;
    margin: 0 1px -7px;
  }
  .heart-mobile-only {
    display: block;
  }
  .heart-desktop-only {
    display: none;
  }

  .signup-container {
    margin: 22px auto 0 auto;
    padding: 0;
    width: 100%;
  }
  .hero-section .signup-container {
    margin-top: 10px;
  }

  .how-it-works-2col {
    width: 100%;
    gap: 0;
  }

  .how-it-works-desc {
    padding-left: 16px;
    padding-right: 16px;
    box-sizing: border-box;
  }
}
/* Small phones (e.g. iPhone SE) need tighter side padding so text has more room */
@media (max-width: 380px) {
  .hello {
    padding: 0 4px;
  }
  .how-it-works-section {
    padding: 0 4px;
  }
  .how-it-works-col {
    padding-left: 8px;
    padding-right: 8px;
  }
  .how-it-works-desc {
    padding-left: 8px;
    padding-right: 8px;
  }
  .logo-tagline {
    padding-left: 6px;
    padding-right: 6px;
  }
}
@media (max-width: 900px) {
  .how-it-works-2col {
    gap: 24px;
    max-width: 98vw;
  }
}
/* Header gets squished on mobile; shrink logo/text/padding but keep everything on one row */
@media (max-width: 600px) {
  .site-header {
    height: 75px;
  }
  .page-content-wrapper {
    padding-top: 75px;
  }
  .site-header-inner {
    padding: 0 12px;
    gap: 10px;
  }
  .header-logo {
    height: 63px;
    margin-left: -4px;
  }
  .site-header-actions {
    gap: 10px;
  }
  .try-free-link {
    font-size: 1.1rem;
  }
  .top-login-link {
    font-size: .95rem;
    padding: 8px 18px;
    margin-right: 0;
  }
}
@media (max-width: 380px) {
  .site-header {
    height: 68px;
  }
  .page-content-wrapper {
    padding-top: 68px;
  }
  .site-header-inner {
    padding: 0 8px;
    gap: 8px;
  }
  .header-logo {
    height: 55px;
    margin-left: -3px;
  }
  .site-header-actions {
    gap: 8px;
  }
  .try-free-link {
    font-size: 1.1rem;
  }
  .top-login-link {
    font-size: .95rem;
    padding: 7px 16px;
  }
}
/* Center paragraph class for centering specific paragraphs */
.center-paragraph {
  text-align: center;
}
/* Add to your <style scoped> section */
.how-it-works-title {
  font-family: 'LemonCupcakeBold', 'Quicksand', Avenir, Helvetica, Arial, sans-serif;
  /* ...existing code... */
}
</style>
